export class Accordion {
    static init(): void {
        this.setEventHandlers();
    }

    private static setEventHandlers(): void {
        const accordionItems = document.querySelectorAll('.accordion-item');

        accordionItems.forEach(item => {
            const icon = item.querySelector('.fas');
            const accordionContent = item.querySelector('.accordion-content');

            item.addEventListener('click', () => {
                icon?.classList.toggle('fa-caret-up');
                icon?.classList.toggle('fa-caret-down');
                accordionContent?.classList.toggle('hidden');
            })
        })
    }
}